module.exports = __webpack_public_path__ + "static/img/squad_template_black.41c94f9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/squad_template_black.png
// module id = nbA2
// module chunks = 94